import React, { useCallback, useEffect } from 'react';
import { Flex, TextV2, ButtonV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { FadeInWrapper, HoneymoonBottomSheetStyle, StyledBanner, StyledHeroImage } from './HoneymoonFundSuccess.styles';

const HERO_IMAGE_URL = 'https://withjoy.com/assets/public/registry/cash%20fund%20flow/honeymoon-visual.png';
const EXPLORE_DESTINATIONS_URL = 'https://withjoy.com/joy-travel/page/stays';

type HoneymoonFundSuccessProps = Readonly<{
  fundTitle: string;
  onRemindLater: () => void;
  onStartExploring: () => void;
  onView: () => void;
}>;

export const HoneymoonFundSuccess: React.FC<HoneymoonFundSuccessProps> = ({ fundTitle, onRemindLater, onStartExploring, onView }) => {
  const { tq } = useTranslation('sharedRegistry');

  useEffect(() => {
    onView();
  }, [onView]);

  const handleExploreDestinations = useCallback(() => {
    onStartExploring();
    window.open(EXPLORE_DESTINATIONS_URL, '_blank', 'noopener,noreferrer');
  }, [onStartExploring]);

  return (
    <FadeInWrapper data-honeymoon-success-marker="true">
      <HoneymoonBottomSheetStyle />
      <Flex
        flexDirection="column"
        alignItems="center"
        paddingX={[5, 7]}
        paddingTop={2}
        paddingBottom={5}
        maxWidth="480px"
        marginX="auto"
      >
        <StyledBanner>
          <TextV2
            typographyVariant="label2"
            color="positive7"
          >
            {tq`Your honeymoon cash fund has been created.`}
          </TextV2>
        </StyledBanner>

        <StyledHeroImage
          src={HERO_IMAGE_URL}
          alt={fundTitle}
        />

        <TextV2
          typographyVariant="hed5"
          textAlign="center"
          marginTop={7}
          marginBottom={3}
        >
          {tq`Your honeymoon starts here!`}
        </TextV2>

        <TextV2
          typographyVariant="body1"
          textAlign="center"
          color="mono10"
          marginBottom={8}
          maxWidth="420px"
        >
          {tq`You've got a cash fund ready to go. Browse destinations, save favorites, and when you're ready to book — you'll get up to 30% off as a Joy member.`}
        </TextV2>

        <ButtonV2
          intent="neutral"
          shape="rounded"
          width={{ _: '100%', md: 'auto' }}
          minWidth="18rem"
          onClick={handleExploreDestinations}
          marginBottom={6}
        >
          {tq`Start exploring destinations`}
        </ButtonV2>

        <ButtonV2
          variant="ghost"
          intent="neutral"
          onClick={onRemindLater}
        >
          {tq`Remind me later`}
        </ButtonV2>
      </Flex>
    </FadeInWrapper>
  );
};
